// extracted by mini-css-extract-plugin
export var compactFilters = "_bl-4";
export var detailImage = "_bl-1";
export var dropdownContainer = "_bl-2";
export var imageContainer = "_bl-0";
export var selectedCard = "_bl-3";